var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-top"},[_c('div',{staticClass:"search_box search_field",staticStyle:{"margin-top":"40px"}},[_c('partner-register-tab',{attrs:{"current-tab":"DETAIL"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }